import { LoadableAfterPaint } from '@confluence/loadable';
import { RendererPageCoverPicturePlaceholder } from '../src/RendererCoverPicture/RendererPageCoverPicturePlaceholder';

export const RendererPageCoverPicture = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-RendererCoverPictureRendererPageCoverPicture" */ '../src/RendererCoverPicture/RendererPageCoverPicture'
			)
		).RendererPageCoverPicture;
	},
	loading: RendererPageCoverPicturePlaceholder,
});
